import type { AmplifyEvent, AmplifyProductClickEvent } from 'types/amplitude';

export const fireAmplitudeEvent = <EventData extends AmplifyEvent>(data: EventData) =>
  new Promise(resolve => {
    if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
      const callback = () => {
        window.dataLayer.push(data);
        resolve(null);
      };
      if (window.requestIdleCallback) {
        window.requestIdleCallback(callback);
        return;
      } else {
        setTimeout(callback, 5);
        return;
      }
    }
    resolve(null);
  });

export const fireAmplitudeProductClickedEvent = (data: AmplifyProductClickEvent) => fireAmplitudeEvent<AmplifyProductClickEvent>(data);
